export function mustGet<K, V>(kind: string, map: Map<K, V>, key: K): V {
  const value = map.get(key);
  if (!value) {
    throw new Error(`${kind} ${JSON.stringify(key)} not found`);
  }
  return value;
}
